<form class="file-uploader" #form="ngForm" [formGroup]="fileForm" *ngIf="rowObject">
    <div class="file-uploader__body">
        <div class="body__desktop">
            <div class="desktop__text-area">
                <span class="text-area__first-line">{{rowObject.row.desktop.number}} - {{rowObject.row.desktop.rowName}}</span>
                <div class="text-area__image" *ngIf="desktopPreviews.length">
                    <img *ngFor='let preview of desktopPreviews' [src]="preview" class="preview">
                </div>
                <span class="text-area__footer">{{rowObject.row.desktop.rowFooterText}}</span>
            </div>
            <div class="desktop__button-area">    
                <button mat-raised-button class="button-area-button button--negative" type="submit" (click)="imageInput.click()">{{desktopPreviews.length ? "TROCAR" : "ADICIONAR"}}</button>
                <input #imageInput hidden="true" type="file" onclick="this.value=null" (change)="selectFiles($event, 1)" accept="image/*"/>
                <button mat-raised-button class="button-area__second-button button__white--negative" (click)="deleteFiles(1)">EXCLUIR</button>
            </div>
        </div>
        <hr>
        <div class="body__mobile">
            <div class="mobile__text-area">
                <span class="text-area__first-line">{{rowObject.row.mobile.number}} - {{rowObject.row.mobile.rowName}}</span>
                <div class="text-area__image" *ngIf="mobilePreviews.length">
                    <img *ngFor='let preview of mobilePreviews' [src]="preview" class="preview">
                </div>
                <span class="text-area__footer">{{rowObject.row.mobile.rowFooterText}}</span>
            </div>
            <div class="mobile__button-area">    
                <button mat-raised-button class="button-area-button button--negative" type="submit" (click)="imageInputMobile.click()">{{mobilePreviews.length ? "TROCAR" : "ADICIONAR"}}</button>
                <input #imageInputMobile hidden="true" type="file" onclick="this.value=null" (change)="selectFiles($event, 2)" accept="image/*"/>
                <button mat-raised-button class="button-area__second-button button__white--negative" (click)="deleteFiles(2)">EXCLUIR</button>
            </div>
        </div>
        <hr *ngIf="desktopPreviews.length">
        <div class="body__link-area" *ngIf="desktopPreviews.length">
            <div class="link-area__text-area">
                <span class="text-area__first-line">Link</span>
                <span class="text-area__footer">Adicione um link novo ou exclua o existente</span>
            </div>
            <div class="link-area__link-box">
                <div class="link-box__text-area">
                    <mat-label class="text-area__label">URL</mat-label>
                    <mat-form-field appearance="outline" class="text-area__form form__field">
                        <input matInput type="text" class="form__input" formControlName="mobileImageLink">
                    </mat-form-field>
                </div>
                <button mat-raised-button class="link-box__button button__white--negative" (click)="deleteLink()">EXCLUIR</button>
            </div>
        </div>
    </div>
    <hr>
</form>